const initialState = {
  lastLoginDate: '',
  previousLoginDate: '',
  userRoles: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_LAST_LOGIN_DATE_REQUESTED': {
      return {
        ...state,
      };
    }
    case 'UPDATE_LAST_LOGIN_DATE_SUCCESS': {
      return {
        ...state,
        lastLoginDate: action.payload.lastLoginDate,
        previousLoginDate: action.payload.previousLoginDate,
      };
    }
    case 'UPDATE_LAST_LOGIN_DATE_FAILURE': {
      return {
        ...initialState,
        error: action.payload.error,
      };
    }
    case 'FETCH_AUTHENTICATED_USER_ROLES_STARTED': {
      return {
        ...state,
      };
    }
    case 'FETCH_AUTHENTICATED_USER_ROLES_SUCCESS': {
      return {
        ...state,
        userRoles: action.userRoles,
      };
    }
    case 'FETCH_AUTHENTICATED_USER_ROLES_FAILED': {
      return {
        ...initialState,
        error: action.payload.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
